import {ParagraphComponent} from "./paragraph.component";

export const Paragraph = ParagraphComponent;
